export default __webpack_public_path__ + "static/media/547.54d2762a.png";